import React, { useState } from "react";

import { AddFilterBaseFunc, IFilterKeys, IFilters, RemoveFilterBaseFunc } from "models/core";
import { DashboardFilterKeys } from "models/mdt";
import { HhsResidenceGroup } from "models/mdt/plotdata";
import { PlotData } from "plotly.js";
import { Dialog } from "@mui/material";
import { addFilterFactory } from "helpers/filterHelper";
import { DashChart } from "components/common/DashChart";
import { ChartIcons } from "components/common/ChartIcons";
import { SimpleBreadcrumb } from "components/common/SimpleBreadcrumb";
import { chartDimesionsCalc, ChartOrientation, ChartType, QoolDashChart } from "../core";
import watermark from "../../static/qca-black.png";
import { CreateChart } from "components/common/CreateChart";
import { defText, defTextTemplate } from "defaults";
import { HHSLabel } from "config/appUrlConfig";

interface IProps {
	plotData: HhsResidenceGroup.IPlotData;
	activeFilters: IFilters<IFilterKeys>;
	addFilterFn: AddFilterBaseFunc<typeof DashboardFilterKeys>;
    removeFilterFn: RemoveFilterBaseFunc<typeof DashboardFilterKeys>;
}

/**
 * Reviews by service chart / My MDTs
 */
export function HHSResidenceGroupPieChart(props: IProps) {

	return (
		<QoolDashChart
			xAxis={{ horizontalOrientation: { label: "Number of Diagnoses" }, verticalOrientation: { label: `${HHSLabel} Residence Group` }  }}
			yAxis={{ horizontalOrientation: { label: `${HHSLabel} Residence Group` }, verticalOrientation: { label: "Number of Diagnoses" }	}}
			chartOrder={{ horizontalOrientation: { reversed: true }, verticalOrientation: { reversed: false } }}
			defaultChartOrientation={ChartOrientation.Vertical}
			defaultChartType={ChartType.Pie}
			chartTitle={`Do patients reside within my ${HHSLabel}?`}
			filterKey={DashboardFilterKeys.HHSResidenceGroup.key}
			plotData={[props.plotData]}
			activeFilters={props.activeFilters}
			addFilterFn={props.addFilterFn}
			removeFilterFn={props.removeFilterFn}
			hoverText="Diagnoses"
			chartIcons={{
				line: false
			}}
			chartDimensions={{
				chartHeightProportion: 50,
				parentColNumber: 12,
				tabColNumber: 4
			}}
		/>
	)
}
